// AI-generated place info section keys (for progressive loading)
export const all = ['placeInfo']

export const detail = (googlePlaceId: string) =>
  ['placeDetail', googlePlaceId]

export const overview = (googlePlaceId: string) =>
  ['placeOverview', googlePlaceId]

export const bestTimeToVisit = (googlePlaceId: string) =>
  ['placeBestTimeToVisit', googlePlaceId]

export const whatToLove = (googlePlaceId: string) =>
  ['placeWhatToLove', googlePlaceId]

export const areas = (googlePlaceId: string) =>
  ['placeAreas', googlePlaceId]

export const insiderTips = (googlePlaceId: string) =>
  ['placeInsiderTips', googlePlaceId]

export const info = (googlePlaceId: string) =>
  ['placeInfo', googlePlaceId]

export const highlights = (googlePlaceId: string) =>
  ['placeHighlights', googlePlaceId]
